/* unplugin-vue-components disabled */import script from "./FootNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FootNav.vue?vue&type=script&setup=true&lang=js"

import "./FootNav.vue?vue&type=style&index=0&id=14aa5550&lang=less&scoped=true"

import exportComponent from "C:\\Users\\小刘\\Desktop\\wanwei\\cydf-h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14aa5550"]])

export default __exports__